module.exports = __webpack_public_path__ + "static/toyota_0-debec4b87c62f3c2eee0c723576f095b.jpg";